import { useAppSelector } from "../../../store/hooks";
import { defaultLanguageCodeFromActiveLanguages } from "../utilities/languageCode";

function usePageLanguage() {
  const pageId = useAppSelector((state) => state.builder.pages.active);
  const currentPage = useAppSelector((state) =>
    state.builder.pages.list.find((x) => x.uuid === pageId)
  );
  const pageLanguages = useAppSelector(
    (state) => state.builder.languageSettings.activeLanguages
  );

  if (
    currentPage &&
    typeof currentPage.languageCode === "string" &&
    currentPage.languageCode.trim() !== ""
  ) {
    return currentPage.languageCode.trim();
  }

  return (
    defaultLanguageCodeFromActiveLanguages(pageLanguages, {
      visitorOnly: true,
    }) || defaultLanguageCodeFromActiveLanguages(pageLanguages)
  );
}

export default usePageLanguage;
